/**
 * Application singletons shared across feature modules.
 */

import { Store } from '@/core/state';
import type { ScoringContext } from '@/core/scoring';
import type { ScoringProfile } from '@/core/scoring-sv';

/** The single app-wide state store. */
export const store = new Store();

/**
 * Authorship context: the user's own side. Everything in src/documents scores
 * and writes through this, so a generated packet always speaks for the attorney
 * regardless of which lens the panel happens to be showing.
 */
export function scoringContext(): ScoringContext {
  const s = store.getState();
  return { side: s.side, activeCharges: s.activeCharges };
}

/**
 * Reading context: the panel's current lens. Everything in src/features that
 * merely *displays* a score reads through this, so the user can look at the
 * panel from across the aisle. Never use it to build a document.
 */
export function panelContext(): ScoringContext {
  const s = store.getState();
  return { side: s.panelLens, activeCharges: s.activeCharges };
}

/** Current SpatchVenire scoring profile: case posture + the recorded parties. */
export function svProfile(): ScoringProfile {
  const s = store.getState();
  return {
    evidence: s.caseProfile.evidence,
    pretrialPublicity: s.caseProfile.pretrialPublicity,
    localCommunityImpact: s.caseProfile.localCommunityImpact,
    victims: s.victims,
    defendant: s.defendant
  };
}
